import React from 'react'

import './email.css'

const Email = () => {
  return (
    <>
      <>a1caredfw@gmail.com</>
    </>
  )
}

export default Email